var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/modules/_to-absolute-index.js